module.exports = __webpack_public_path__ + "media/images/lp_cv-block-4-sp-96c29e6d384fdc9dde093bbcc98dc7d8.webp";